import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { map } from "rxjs";

import { DeviceType } from "@vowkey/common/enums";
import { PlatformUtilsService } from "@vowkey/common/platform/abstractions/platform-utils.service";
import { LinkModule } from "@vowkey/components";
import { I18nPipe } from "@vowkey/ui-common";

import {
  BrowserExtensionPromptService,
  BrowserPromptState,
} from "../../services/browser-extension-prompt.service";

/** Device specific Urls for the extension  */
const WebStoreUrls: Partial<Record<DeviceType, string>> = {
  [DeviceType.ChromeBrowser]: "https://vowkey.app/#download",
  [DeviceType.FirefoxBrowser]: "https://vowkey.app/#download",
  [DeviceType.SafariBrowser]: "https://vowkey.app/#download",
  [DeviceType.OperaBrowser]: "https://vowkey.app/#download",
  [DeviceType.EdgeBrowser]: "https://vowkey.app/#download",
};

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "vault-browser-extension-prompt-install",
  templateUrl: "./browser-extension-prompt-install.component.html",
  imports: [CommonModule, I18nPipe, LinkModule],
})
export class BrowserExtensionPromptInstallComponent implements OnInit {
  /** The install link should only show for the error states */
  protected shouldShow$ = this.browserExtensionPromptService.pageState$.pipe(
    map((state) => state === BrowserPromptState.Error || state === BrowserPromptState.ManualOpen),
  );

  /** All available page states */
  protected BrowserPromptState = BrowserPromptState;

  /**
   * Installation link for the extension
   */
  protected webStoreUrl: string = "https://vowkey.app/#download";

  constructor(
    private browserExtensionPromptService: BrowserExtensionPromptService,
    private platformService: PlatformUtilsService,
  ) {}

  ngOnInit(): void {
    this.setBrowserStoreLink();
  }

  /** If available, set web store specific URL for the extension */
  private setBrowserStoreLink(): void {
    const deviceType = this.platformService.getDevice();
    const platformSpecificUrl = WebStoreUrls[deviceType];

    if (platformSpecificUrl) {
      this.webStoreUrl = platformSpecificUrl;
    }
  }
}
